import { createStore } from "vuex";

import categories from "./modules/categories";
import categorizedMessages from "./modules/categorized-messages";
import clientApplications from "./modules/client-applications";
import config from "./modules/config";
import conversationWebhooks from "./modules/conversation-webhooks";
import conversations from "./modules/conversations";
import currentTeam from "./modules/current-team";
import currentUser from "./modules/current-user";
import dealerships from "./modules/dealerships";
import integrations from "./modules/integrations";
import messages from "./modules/messages";
import queries from "./modules/queries";
import wrongcfgevents from "./modules/wrongcfgevents";

const store = createStore({
  modules: {
    categories,
    categorizedMessages,
    clientApplications,
    config,
    conversationWebhooks,
    conversations,
    currentTeam,
    currentUser,
    integrations,
    messages,
    queries,
    dealerships,
    wrongcfgevents
  }
});

export default store;
